export default __webpack_public_path__ + "static/42779-461c41519b9e6be198d3454bfcca92db.jpg";